var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5835 13.375V6.625M13.0835 13.375V6.625M10.8335 19C5.86293 19 1.8335 14.9706 1.8335 10C1.8335 5.02944 5.86293 1 10.8335 1C15.8041 1 19.8335 5.02944 19.8335 10C19.8335 14.9706 15.8041 19 10.8335 19Z",
    stroke: "#F6A723",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedIcon);
export default __webpack_public_path__ + "static/media/PausedIcon.2d244557fefa577c2d4ba9c91527cc7b.svg";
export { ForwardRef as ReactComponent };